function createRoutes(asyncRoutes, roleRoutes){
    let routes = []
    asyncRoutes.forEach(asyncRoute => {
        if(!roleRoutes){
            return
        }
        let route = roleRoutes.find(roleRoute => roleRoute.path === asyncRoute.path)
        if(route){
            if(asyncRoute.children && asyncRoute.children.length){
                asyncRoute.children = createRoutes(asyncRoute.children, route.child)
            }else{
                if(!asyncRoute.meta){
                    asyncRoute.meta = {}
                }
                if(route.permission){
                    asyncRoute.meta.btnPermissions = route.permission
                }
            }
            routes.push(asyncRoute)
        }
    })
    return routes
}

function routersHandler(routes, redirect, completePath){
    routes.forEach(route => {
        if(route.children && route.children.length){
            if(redirect){
                route.redirectPath = redirect + '/' + route.children[0].path
            }else{
                route.redirectPath = route.path + '/' + route.children[0].path
            }
            routersHandler(route.children, route.redirectPath, completePath ? completePath + '/' + route.path : route.path)
        }else{
            if(completePath){
                route.completePath = completePath + '/' + route.path
            }else{
                route.completePath = route.path
            }
        }
    })
    return routes
}


export default function(asyncRoutes, roleRoutes){
    return routersHandler(createRoutes(asyncRoutes, roleRoutes))
}


// WEBPACK FOOTER //
// ./src/utils/createRoutes.js